import { useQuery } from '@tanstack/react-query';
import { IoMegaphoneOutline, IoTimeOutline, IoCheckmarkCircle } from 'react-icons/io5';
import { api } from '../api';

export function ActionsPage() {
  const data = useQuery({ queryKey: ['actions'], queryFn: api.actionsList });

  return (
    <>
      <div className="page-header">
        <div>
          <h2>Акции Ozon</h2>
          <div className="muted" style={{ fontSize: 13, marginTop: 4 }}>
            <IoMegaphoneOutline style={{ verticalAlign: 'middle' }} /> Активные и предстоящие промо-акции
          </div>
        </div>
      </div>

      {data.isLoading && <div className="card">Загрузка…</div>}
      {data.error && <div className="card" style={{ color: 'var(--red)' }}>{(data.error as Error).message}</div>}

      {data.data && (
        <>
          <div className="muted" style={{ marginBottom: 12, fontSize: 13 }}>
            Всего акций: <strong style={{ color: 'var(--text)' }}>{data.data.items.length}</strong>
            {' · '}
            активных: <strong style={{ color: 'var(--green)' }}>{data.data.items.filter((a) => a.isActive).length}</strong>
            {' · '}
            участвуем в: <strong style={{ color: 'var(--accent)' }}>{data.data.items.filter((a) => a.isParticipating).length}</strong>
          </div>

          {data.data.items.length === 0 && <div className="card empty">Акций сейчас нет.</div>}

          <div style={{ display: 'grid', gap: 12 }}>
            {data.data.items.sort((a, b) => Number(b.isActive) - Number(a.isActive) || a.daysLeft - b.daysLeft).map((a) => (
              <div key={a.id} className="card" style={{ padding: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                  <div>
                    <h3 style={{ margin: 0, fontSize: 16 }}>{a.title}</h3>
                    <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>
                      Тип: {a.type}
                      {a.discountType && a.discountValue && ` · скидка ${a.discountValue} ${a.discountType === 'PERCENT' ? '%' : '₽'}`}
                    </div>
                    {a.description && <div className="muted" style={{ fontSize: 13, marginTop: 8, maxWidth: 600, lineHeight: 1.5, whiteSpace: 'pre-line' }}>{stripHtml(a.description)}</div>}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-end' }}>
                    {a.isParticipating ? (
                      <span className="badge badge-success"><IoCheckmarkCircle /> Участвуем</span>
                    ) : a.potentialCount > 0 ? (
                      <span className="badge badge-info">Доступно</span>
                    ) : null}
                    {a.isActive ? (
                      <span className="badge badge-success">● активна</span>
                    ) : (
                      <span className="badge">○ не активна</span>
                    )}
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginTop: 16 }}>
                  <div>
                    <div className="filter-field-label">Период</div>
                    <div style={{ fontSize: 13 }}>
                      {new Date(a.dateStart).toLocaleDateString('ru-RU')} — {new Date(a.dateEnd).toLocaleDateString('ru-RU')}
                    </div>
                    {a.daysLeft >= 0 && (
                      <div className="muted" style={{ fontSize: 11, marginTop: 2 }}>
                        <IoTimeOutline style={{ verticalAlign: 'middle' }} /> {a.daysLeft > 0 ? `${a.daysLeft} дн.` : 'сегодня'}
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="filter-field-label">Участвует наших</div>
                    <div style={{ fontSize: 16, fontWeight: 600, color: a.participatingCount > 0 ? 'var(--accent)' : 'var(--text-muted)' }}>
                      {a.participatingCount}
                    </div>
                  </div>
                  <div>
                    <div className="filter-field-label">Можем добавить</div>
                    <div style={{ fontSize: 16, fontWeight: 600, color: a.potentialCount > 0 ? 'var(--green)' : 'var(--text-muted)' }}>
                      {a.potentialCount}
                    </div>
                  </div>
                  {a.bannedCount > 0 && (
                    <div>
                      <div className="filter-field-label">Заблокировано</div>
                      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--red)' }}>{a.bannedCount}</div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}

// Удаляет HTML-теги и декодирует основные entities из описаний Ozon-акций.
function stripHtml(html: string): string {
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li)>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
